export default __webpack_public_path__ + "static/media/rub-hands.adb143b1.webp";